import React from 'react'

const LargeLogoIcon = (
  <>
    <g clipPath="url(#clip0_1965_2672)">
      <path
        d="M61.1585 28.21V32.318H48.4844V10.478H52.8045V28.21H61.1585Z"
        fill="white"
      />
      <path
        d="M61.445 24.518C61.4398 22.8805 61.9215 21.2784 62.8289 19.9148C63.7362 18.5511 65.0285 17.4873 66.5418 16.8583C68.0551 16.2293 69.7212 16.0634 71.329 16.3816C72.9368 16.6998 74.4138 17.4878 75.5728 18.6456C76.7318 19.8035 77.5205 21.2791 77.839 22.8854C78.1575 24.4916 77.9914 26.1562 77.3618 27.668C76.7322 29.1799 75.6674 30.4709 74.3025 31.3774C72.9375 32.2839 71.3339 32.7651 69.6949 32.76C68.6086 32.7704 67.5311 32.5643 66.5255 32.1538C65.5198 31.7433 64.6062 31.1366 63.8381 30.3692C63.0699 29.6017 62.4626 28.689 62.0517 27.6843C61.6408 26.6797 61.4345 25.6032 61.445 24.518ZM73.963 24.518C73.963 21.996 72.1152 20.202 69.6949 20.202C67.2745 20.202 65.4788 21.996 65.4788 24.518C65.4788 27.04 67.3266 28.834 69.6949 28.834C72.0631 28.834 73.963 27.04 73.963 24.518Z"
        fill="white"
      />
      <path
        d="M95.6156 16.718V31.59C95.6156 36.712 91.5818 39 87.4698 39C84.1126 39 81.432 37.726 80.0527 35.204L83.488 33.228C84.1386 34.45 85.1796 35.412 87.5739 35.412C89.9682 35.412 91.6859 34.034 91.6859 31.59V29.9C90.5928 31.356 88.9012 32.266 86.6631 32.266C82.2388 32.266 78.8816 28.678 78.8816 24.258C78.8816 19.838 82.2388 16.276 86.6631 16.276C88.9012 16.276 90.5928 17.186 91.6859 18.642V16.718H95.6156ZM91.6859 24.258C91.6859 21.814 89.8381 20.02 87.3137 20.02C84.7893 20.02 82.9155 21.814 82.9155 24.258C82.9155 26.702 84.7632 28.548 87.3137 28.548C89.8641 28.548 91.6859 26.78 91.6859 24.258Z"
        fill="white"
      />
      <path
        d="M129.032 22.698V32.318H124.998V22.984C124.998 21.138 124.061 20.02 122.369 20.02C120.678 20.02 119.481 21.216 119.481 23.556V32.318H115.447V22.984C115.447 21.138 114.51 20.02 112.818 20.02C111.127 20.02 109.877 21.216 109.877 23.556V32.318H105.844V16.718H109.877V18.356C110.736 17.056 112.22 16.276 114.224 16.276C116.227 16.276 117.581 17.082 118.466 18.512C119.429 17.108 120.99 16.276 123.124 16.276C126.689 16.276 129.032 18.798 129.032 22.698Z"
        fill="white"
      />
      <path
        d="M145.219 16.718L139.52 32.318C137.906 36.816 135.252 38.792 131.27 38.584V34.814C133.482 34.866 134.627 33.93 135.356 31.824L128.954 16.718H133.352L137.438 27.196L140.899 16.718H145.219Z"
        fill="white"
      />
      <path
        d="M152.871 21.398C152.871 15.002 157.633 10.036 164.243 10.036C168.251 10.036 171.791 12.064 173.665 15.184L169.943 17.342C168.876 15.392 166.742 14.222 164.243 14.222C159.975 14.222 157.165 17.186 157.165 21.398C157.165 25.61 159.975 28.548 164.243 28.548C166.742 28.548 168.902 27.352 169.943 25.454L173.665 27.612C171.817 30.732 168.277 32.76 164.243 32.76C157.633 32.76 152.871 27.768 152.871 21.398Z"
        fill="white"
      />
      <path
        d="M191.049 16.718V32.318H187.015V30.498C185.896 31.902 184.205 32.76 181.914 32.76C177.75 32.76 174.315 29.172 174.315 24.518C174.315 19.864 177.75 16.276 181.914 16.276C184.205 16.276 185.896 17.16 187.015 18.564V16.718H191.049ZM187.015 24.518C187.015 21.892 185.168 20.124 182.669 20.124C180.171 20.124 178.349 21.892 178.349 24.518C178.349 27.144 180.197 28.912 182.669 28.912C185.142 28.912 187.015 27.144 187.015 24.518Z"
        fill="white"
      />
      <path
        d="M202.474 16.406V20.904C200.392 20.644 197.712 21.58 197.712 24.856V32.318H193.678V16.718H197.712V19.396C198.544 17.264 200.496 16.406 202.474 16.406Z"
        fill="white"
      />
      <path
        d="M211.479 29.12C213.04 29.12 214.29 28.444 214.966 27.56L218.219 29.432C216.762 31.538 214.42 32.76 211.401 32.76C206.144 32.76 202.839 29.172 202.839 24.518C202.839 19.864 206.196 16.276 211.089 16.276C215.981 16.276 219 19.942 219 24.518C219.002 25.0764 218.95 25.6337 218.844 26.182H207.055C207.627 28.236 209.345 29.12 211.479 29.12ZM214.966 23.062C214.472 20.8 212.78 19.89 211.089 19.89C208.928 19.89 207.471 21.06 207.003 23.062H214.966Z"
        fill="white"
      />
      <path
        d="M10.8523 10.998C10.8523 11.83 10.8783 12.662 10.9304 13.468C12.1343 14.175 13.1796 15.122 14.0013 16.25C19.3625 23.14 21.4965 35.984 21.4965 35.984C21.4965 35.984 29.1478 21.788 29.1478 10.998C29.1478 -3.40599 10.8523 -3.92599 10.8523 10.998Z"
        fill="url(#paint0_linear_1965_2672)"
      />
      <path
        d="M10.9305 13.4681C4.03393 9.41205 -4.05984 17.03 2.31628 25.2721C10.0977 35.3081 21.4967 35.9841 21.4967 35.9841C21.4967 35.9841 11.9715 27.6641 10.9305 13.4681Z"
        fill="url(#paint1_linear_1965_2672)"
      />
      <path
        d="M10.9304 13.468C11.9714 27.664 21.4966 35.984 21.4966 35.984C21.4966 35.984 19.3625 23.14 14.0014 16.25C13.1796 15.122 12.1343 14.175 10.9304 13.468Z"
        fill="url(#paint2_linear_1965_2672)"
      />
      <path
        d="M10.9304 13.468C11.9714 27.664 21.4966 35.984 21.4966 35.984C21.4966 35.984 19.3625 23.14 14.0014 16.25C13.1796 15.122 12.1343 14.175 10.9304 13.468Z"
        fill="#F0007E"
      />
      <path
        d="M35.602 27.378C34.6491 28.3843 33.4984 29.183 32.2221 29.7244C30.9458 30.2657 29.5714 30.538 28.1849 30.524C28.095 29.138 28.2932 27.7484 28.7672 26.4427C29.2411 25.1369 29.9805 23.9434 30.9388 22.9371C31.8972 21.9309 33.0536 21.1338 34.3354 20.5959C35.6172 20.0581 36.9966 19.7912 38.3867 19.812C38.4729 21.1971 38.2698 22.585 37.7904 23.8875C37.311 25.19 36.5658 26.3787 35.602 27.378Z"
        fill="url(#paint3_linear_1965_2672)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1965_2672"
        x1="9.06958"
        y1="32.4298"
        x2="27.3923"
        y2="3.9672"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF0099" />
        <stop offset="1" stopColor="#FFCC00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1965_2672"
        x1="7.59934"
        y1="31.4808"
        x2="25.9195"
        y2="3.01825"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF0099" />
        <stop offset="1" stopColor="#FFCC00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1965_2672"
        x1="10.6181"
        y1="33.4256"
        x2="28.9382"
        y2="4.96301"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF0099" />
        <stop offset="1" stopColor="#FFCC00" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1965_2672"
        x1="22.8628"
        y1="41.3088"
        x2="41.1856"
        y2="12.8462"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF0099" />
        <stop offset="1" stopColor="#FFCC00" />
      </linearGradient>
      <clipPath id="clip0_1965_2672">
        <rect width="219" height="39" fill="white" />
      </clipPath>
    </defs>
  </>
)

export default LargeLogoIcon
